module.exports = __webpack_public_path__ + "static/media/1.2da65959.jpg";